module.exports = require("./om-KE.d.ts");